import { useEffect, useState } from "react";
import axios from "axios";

const avatars = [
  "https://images.unsplash.com/photo-1698650427325-d9c575dd6109?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0JTIwZGl2ZXJzZXxlbnwwfHx8fDE3NzUyMzMzMDd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1609371497456-3a55a205d5eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0JTIwZGl2ZXJzZXxlbnwwfHx8fDE3NzUyMzMzMDd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1697063882499-f7fca7d2d713?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0JTIwZGl2ZXJzZXxlbnwwfHx8fDE3NzUyMzMzMDd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1609436132311-e4b0c9370469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0JTIwZGl2ZXJzZXxlbnwwfHx8fDE3NzUyMzMzMDd8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/5999897/pexels-photo-5999897.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];

export default function SocialProofSection({ api }) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        const res = await axios.get(`${api}/waitlist/count`);
        setCount(res.data.count);
      } catch {
        setCount(0);
      }
    };
    fetchCount();
  }, [api]);

  const displayCount = count !== null ? (count + 4000).toLocaleString() : "4,000";

  return (
    <section data-testid="social-proof-section" className="py-12 sm:py-14 border-y border-violet-500/[0.08]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="reveal flex flex-col sm:flex-row items-center justify-center gap-4">
          {/* Avatar stack */}
          <div data-testid="avatar-stack" className="flex -space-x-3">
            {avatars.map((url, i) => (
              <img
                key={i}
                src={url}
                alt=""
                className="w-10 h-10 rounded-full border-2 border-violet-950/80 object-cover ring-1 ring-violet-500/20"
              />
            ))}
          </div>

          <div className="text-center sm:text-left">
            <p data-testid="waitlist-count" className="text-sm font-semibold text-violet-100/90">
              Join {displayCount}+ early adopters
            </p>
            <p className="text-xs text-violet-200/40">
              Founders, freelancers, and agencies on the waitlist.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
